/**
 * Transient success confirmation, centred at the bottom of the viewport — the prototype's
 * `toast('…')` (agent-studio.html:11310). Distinct from `Toast`, which is the dismissible
 * error/warning surface. Purely informational: `role="status"` and no pointer events, so it
 * never steals focus or blocks a click.
 *
 * The caller owns the timer (see MambuMcp.tsx / MambuMcpDetail.tsx).
 */
export function SuccessToast({ message }: { message: string }) {
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--text-primary)',
        color: 'var(--bg-card)',
        padding: '10px 18px',
        borderRadius: 8,
        fontSize: 13,
        fontWeight: 500,
        zIndex: 9999,
        boxShadow: '0 6px 20px rgba(0,0,0,.25)',
        pointerEvents: 'none',
      }}
    >
      {message}
    </div>
  )
}
